import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

export const visits = [
  {
    path: '/visits',
    name: ERouterList.VISITS,
    component: () => import('@internal/pages/visits/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits',
    name: ERouterList.VISITS_LOCATION,
    component: () => import('@internal/pages/visits/index.location.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId',
    name: ERouterList.VISIT,
    component: () => import('@internal/pages/visits/_id/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/schedule',
    name: ERouterList.VISIT_SCHEDULE,
    component: () => import('@internal/pages/visits/schedule.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/preview',
    name: ERouterList.VISIT_MEETING_PREVIEW,
    component: () => import('@internal/pages/visits/_id/meeting-preview.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/meeting',
    name: ERouterList.VISIT_MEETING,
    component: () => import('@internal/pages/visits/_id/meeting.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/add-files',
    name: ERouterList.VISIT_ADD_FILES,
    component: () => import('@internal/pages/visits/_id/add-files.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/manage-files',
    name: ERouterList.VISIT_MANAGE_FILES,
    component: () => import('@internal/pages/visits/_id/manage-files.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/:documentId',
    name: ERouterList.VISIT_DOCUMENT,
    component: () => import('@internal/pages/visits/_id/_documentId/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/task/:taskId/complete',
    name: ERouterList.VISIT_REMINDER_COMPLETE,
    component: () => import('@internal/pages/visits/_id/_taskId/complete.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/:visitId/task/:taskId/cancel',
    name: ERouterList.VISIT_REMINDER_CANCEL,
    component: () => import('@internal/pages/visits/_id/_taskId/cancel.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/visits/filter',
    name: ERouterList.VISITS_FILTER,
    component: () => import('@internal/pages/visits/filter.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
]

export default visits
